module.exports = __webpack_public_path__ + "static/media/message.56469f6a.svg";